import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Calendar, ArrowRight, Clock } from 'lucide-react';
export function BlogPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const posts = [{
    title: 'How to Tell If Your Roof Needs Replacing in Michigan',
    excerpt: 'Learn the key warning signs that indicate your roof may need replacement, from curling shingles to interior water stains.',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=600&q=80',
    date: 'March 15, 2024',
    readTime: '5 min read',
    category: 'Roofing'
  }, {
    title: 'The Complete Guide to Gutter Maintenance in Southeast Michigan',
    excerpt: 'Discover why regular gutter maintenance is critical for Michigan homeowners and how to keep your system flowing properly.',
    image: 'https://images.unsplash.com/photo-1585129777188-94600bc7b4b3?w=600&q=80',
    date: 'February 28, 2024',
    readTime: '4 min read',
    category: 'Gutters'
  }, {
    title: 'Vinyl vs. Fiber Cement Siding: Which Is Right for Your Home?',
    excerpt: 'Compare the pros, cons, costs, and longevity of the two most popular siding options for Michigan homes.',
    image: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=600&q=80',
    date: 'February 10, 2024',
    readTime: '6 min read',
    category: 'Siding'
  }, {
    title: 'What to Do After a Hailstorm Damages Your Roof',
    excerpt: 'Step-by-step guide for Michigan homeowners on documenting damage, filing insurance claims, and getting repairs done right.',
    image: 'https://images.unsplash.com/photo-1515694346937-94d85e41e6f0?w=600&q=80',
    date: 'January 22, 2024',
    readTime: '5 min read',
    category: 'Storm Damage'
  }, {
    title: '5 Signs You Need New Windows Before Winter',
    excerpt: "Don't wait for the first freeze — here are the telltale signs your windows are costing you money and comfort.",
    image: 'https://images.unsplash.com/photo-1583608205776-bfd35f0d9f83?w=600&q=80',
    date: 'January 8, 2024',
    readTime: '4 min read',
    category: 'Windows'
  }, {
    title: 'Understanding Commercial Roof Coatings: TPO vs. EPDM vs. Silicone',
    excerpt: "A business owner's guide to the three most common commercial flat roof systems and which one is right for your building.",
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&q=80',
    date: 'December 15, 2023',
    readTime: '7 min read',
    category: 'Commercial'
  }];
  return <div className="w-full bg-white" data-id="element-513">
      {/* Hero */}
      <section className="relative min-h-[35vh] flex items-center pt-20 pb-12 overflow-hidden bg-brand-gray-dark" data-id="element-514">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full relative z-10" data-id="element-515">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-516">
            <h1 className="font-heading font-black text-4xl md:text-5xl text-white mb-4" data-id="element-517">
              Blog & <span className="text-brand-blue" data-id="element-518">Resources</span>
            </h1>
            <p className="font-body text-xl text-gray-300 max-w-2xl" data-id="element-519">
              Expert tips, guides, and insights on roofing, siding, gutters, and
              home exterior care for Michigan homeowners.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="py-20" data-id="element-520">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-521">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-522">
            {posts.map((post, index) => <motion.article key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300 group flex flex-col" data-id="element-523">
                <div className="relative aspect-[16/10] overflow-hidden" data-id="element-524">
                  <div className="brand-overlay h-full" data-id="element-525">
                    <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-526" />
                  </div>
                  <span className="absolute top-4 left-4 bg-brand-blue text-white text-xs font-body font-bold px-3 py-1 rounded-full z-10" data-id="element-527">
                    {post.category}
                  </span>
                </div>
                <div className="p-6 flex flex-col flex-grow" data-id="element-528">
                  <div className="flex items-center gap-4 text-xs text-brand-gray font-body mb-3" data-id="element-529">
                    <span className="flex items-center gap-1" data-id="element-530">
                      <Calendar size={14} data-id="element-531" /> {post.date}
                    </span>
                    <span className="flex items-center gap-1" data-id="element-532">
                      <Clock size={14} data-id="element-533" /> {post.readTime}
                    </span>
                  </div>
                  <h2 className="font-heading font-bold text-xl text-brand-gray-dark mb-3 group-hover:text-brand-blue transition-colors leading-tight" data-id="element-534">
                    {post.title}
                  </h2>
                  <p className="font-body text-brand-gray text-sm mb-6 flex-grow" data-id="element-535">
                    {post.excerpt}
                  </p>
                  <span className="inline-flex items-center gap-2 text-brand-blue font-body font-bold text-sm mt-auto" data-id="element-536">
                    Read Article{' '}
                    <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-537" />
                  </span>
                </div>
              </motion.article>)}
          </div>
        </div>
      </section>
    </div>;
}